import PropTypes from 'prop-types';

export const ArquivoColuna = () => null;

ArquivoColuna.propTypes = {
  id: PropTypes.string,
  titulo: PropTypes.node,
  valor: PropTypes.func.isRequired
};

export default ArquivoColuna;
